<section class="mx-auto max-w-[1100px] px-6 py-9 sm:px-8 lg:px-0">
  <div class="mb-6 max-w-2xl">
    <div class="mb-3 flex h-1.5 w-[30px] gap-1">
      <span class="flex-1 rounded bg-(--cmr-vert)"></span>
      <span class="flex-1 rounded bg-(--cmr-rouge)"></span>
      <span class="flex-1 rounded bg-(--cmr-jaune)"></span>
    </div>
    <div class="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">{{ 'pages.home.news.eyebrow' | translate }}</div>
    <h1 class="mt-2 text-3xl font-extrabold leading-tight text-(--text-body) sm:text-4xl">{{ 'pages.home.news.title' | translate }}</h1>
  </div>

  @if (loading()) {
    <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'common.loading' | translate }}</p>
  } @else if (error()) {
    <p class="py-12 text-center text-[13.5px] text-(--state-danger)" role="alert">
      {{ 'pages.news.loadError' | translate }}
    </p>
  } @else if (items().length > 0) {
    <div class="grid gap-4 sm:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]">
      @for (item of items(); track item.id; let i = $index) {
        <a [appScrollReveal]="i" [routerLink]="['/news', item.slug]"
          class="group flex h-full flex-col overflow-hidden rounded-2xl border border-(--border-subtle) bg-white shadow-card transition hover:-translate-y-1 hover:shadow-(--shadow-raised)">
          <article class="flex h-full flex-col">
            <div class="flex h-48 shrink-0 items-end overflow-hidden bg-(--pnud-bleu) bg-cover bg-center p-4 text-sm text-white/70 transition-transform duration-500 ease-out group-hover:scale-110"
              [style.background-image]="item.imageUrl ? 'url(' + item.imageUrl + ')' : null">
              @if (!item.imageUrl) {
                {{ item.categoryLabelKey | translate }}
              }
            </div>
            <div class="flex flex-1 flex-col space-y-3 p-5">
              <span class="inline-flex w-fit rounded-full px-3 py-1 text-[13px] font-bold"
                [class]="item.categoryTextClass + ' bg-(--surface-primary-tint)'">{{ item.categoryLabelKey | translate }}</span>
              <h2 class="line-clamp-2 text-[16px] font-extrabold leading-tight text-(--text-body)">{{ item.title }}</h2>
              @if (item.summary) {
                <p class="line-clamp-3 text-sm leading-6 text-slate-600">{{ item.summary }}</p>
              }
              @if (item.publishedAt) {
                <div class="mt-auto text-[12.5px] text-(--text-muted)">{{ item.publishedAt | localizedDate }}</div>
              }
            </div>
          </article>
        </a>
      }
    </div>
  } @else {
    <div class="box-border rounded-md border border-(--border-subtle) bg-white px-6 py-12 text-center">
      <p class="m-0 text-[14px] text-(--text-muted)">{{ 'pages.news.empty' | translate }}</p>
    </div>
  }
</section>
